import { useNavigate } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';


const NoneToDisplay = ({ object }) => {
    const navigate = useNavigate()

    return(
        <Stack direction='column' alignItems='center' justifyContent='center'> 
            <Typography variant="body1" textAlign="center" sx={{ my: 3 }}>
                There are currently no {object} to display
            </Typography>
            <Stack direction="row" spacing={2}>
                <Button color="secondary" variant="outlined" onClick={() => navigate('/')}>
                    Home
                </Button>
                <Button color="primary" variant="contained" onClick={() => navigate('/inputs')}>
                    New Simulation
                </Button>
            </Stack>
        </Stack>
    )
}

export default NoneToDisplay